import { useEffect, useState, React } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import '../../styles/Legend.css'

interface LegendProps {
  minColor: string;
  maxColor: string;
  minValue: string;
  maxValue: string;
}
const ColorRangeBar = ({ minColor, maxColor, minValue, maxValue }) => {
  const map = useMap();
  const [legendContent, setLegendContent] = useState(null);

  useEffect(() => {
    const legend = L.control({ position: 'bottomright' });

    legend.onAdd = () => {
      const div = L.DomUtil.create('div', 'info legend');
      setLegendContent(div);
      return div;
    };

    legend.addTo(map);
    return () => {
      legend.remove();
    };
  }, [map]);

  const gradientStyle = {
    width: '9px',
    height: '144px',
    background: `linear-gradient(to top, ${minColor}, ${maxColor})`,
    borderRadius: '5px',
  };

  return (
    legendContent && (
      <div className="leaflet-bottom leaflet-right leaflet-legend mb-4">
        <div className="info legend">
          <div className="legend-content">
            <div style={gradientStyle}></div>
            <div className='range'>
              <span>{`> ${maxValue}`}</span>
              <span>{`< ${minValue}`}</span>
            </div>
          </div>

        </div>
      </div>
    )
  );
};

export default ColorRangeBar;
